export default __webpack_public_path__ + "static/media/whatsapp.cf92aa75.png";